import { render, staticRenderFns } from "./VerticalNavMenuItemsMyDashboard.vue?vue&type=template&id=68f3e732&"
import script from "./VerticalNavMenuItemsMyDashboard.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItemsMyDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports